'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const MoodTrendChartInner = dynamic(
  () => import('./MoodTrendChartInner'),
  { ssr: false, loading: () => <div className="animate-pulse bg-muted rounded-xl h-[320px] w-full" /> }
);

export default function MoodTrendChart() {
  return <MoodTrendChartInner />;
}